import { defineMessages } from 'react-intl';
export default defineMessages({
  headerTitle: {
    id: 'header.title',
  },
  headerSubtitle: {
    id: 'header.subtitle',
  },
});
